export enum SendindStatesEnum {
    sending,
    sent,
    none
}
